import logger from './logger';

/**
 * Helper method used to process screenshots captured by the {@code ScreenshotCaptureEffect}.
 *
 * @param {Blob} imageBlob - The blob of the screenshot that has to be processed.
 * @param {Object} options - Custom options required for processing.
 * @returns {Promise<void>}
 */
export async function processScreenshot(imageBlob, options) {
    const { _screenshotHistoryUrl } = config;

    if (!_screenshotHistoryUrl) {
        return;
    }

    const { jid, jwt, sessionId, timestamp, meetingFqn, participants } = options;
    const headers = {
        ...jwt && { 'Authorization': `Bearer ${jwt}` }
    };
    const metadata = {
        contentType: 'JPEG',
        jid,
        sessionId,
        timestamp,
        meetingFqn,
        participants
    };

    const data = new FormData();

    data.append('stringifyMetadata', JSON.stringify(metadata));
    data.append('file', imageBlob);

    try {
        await fetch(
            _screenshotHistoryUrl,
            {
                body: data,
                headers,
                method: 'POST'
            }
        );
    } catch (err) {
        logger.warn(`Could not send screenshot: ${err}`);
    }
}
